// extracted by mini-css-extract-plugin
export default {"helloText":"greetingsText_helloText__gadFf","greetings":"greetingsText_greetings__jXXqO"};